import { render, staticRenderFns } from "./towerWarn1.vue?vue&type=template&id=49850aed&scoped=true&"
import script from "./towerWarn1.vue?vue&type=script&lang=js&"
export * from "./towerWarn1.vue?vue&type=script&lang=js&"
import style0 from "./towerWarn1.vue?vue&type=style&index=0&id=49850aed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49850aed",
  null
  
)

export default component.exports